export interface UserProfile {
    language: string;
    locale: string;
    email: string;
    /** Tenant role (admin/member/viewer), null for callers without a linked profile (e.g. system accounts). */
    role: string | null;
    _links?: {
        person?: { href: string; name: string };
    };
}

/** Case-insensitive since the backend's exact casing for the role string isn't guaranteed at this boundary. */
export function isAdminRole(role: string | null | undefined): boolean {
    return role?.toLowerCase() === 'admin';
}

export function isViewerRole(role: string | null | undefined): boolean {
    return role?.toLowerCase() === 'viewer';
}